import { httpRequest } from '@v4/http/request';

/**
 * Gets search results
 *
 * @param {string} url
 * @returns {Promise<object>}
 */
export const getSearchResults = (url) =>
    httpRequest({
        url,
        timeout: 2500,
        cache: false,
    });
